import { HeatMap } from "./heat-map";
export default HeatMap;
